// styles/blitzPayStyles.js
import { styled } from "@mui/material/styles";
import { Box, Button, Badge } from "@mui/material";

export const HeaderSection = styled(Box)(({ theme }) => ({
  // backgroundColor: theme.palette.background.paper,
  // borderBottom: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(3),
  // boxShadow: theme.shadows[1],
}));

export const ActionButton = styled(Button)(({ theme }) => ({
  width: '100%',
  height: 48,
  borderRadius: 12,
  textTransform: 'none',
  fontWeight: 600,
  fontSize: '0.95rem',
  boxShadow: theme.shadows[2],
  transition: 'all 0.3s ease',
  '&:hover': {
    boxShadow: theme.shadows[6],
  },
}));

export const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    top: -2,
    right: -2,
    minWidth: 18,
    height: 18,
    fontSize: '0.7rem',
    fontWeight: 600,
  },
}));

export const TabBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    top: 2,
    right: -8,
    minWidth: 16,
    height: 16,
    fontSize: '0.65rem',
    fontWeight: 600,
    transform: 'scale(0.9)',
  },
}));